<template>
  <div class="item-wrapper">
    <span class="text-body item-name">{{ name }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SearchItem',
  props: {
    name: String
  }
}
</script>

<style lang="scss" scoped>
.item-wrapper {
  display: flex;
  flex-flow: column;
  width: 325px;
  margin-left: 15px;
  font-family: 'PingFangSC-Regular, sans-serif';
  margin-bottom: 5px;

  .item-name {
    font-size: 14px;
    line-height: 12px;
    font-weight: 400;
    margin-bottom: 2px;
    margin-top: 4px;
    color: #E5E8EF;
    font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
  }

  /deep/ .el-select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseSearchItem.vue